<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-09 14:13:38
 * @LastEditTime: 2021-01-26 09:23:28
-->
<template>
  <div style="flex: 1;white-space: nowrap;">
     <el-dropdown trigger="click" style="width: 100%; background-color: white" placement="bottom-start" ref="dropdown">
      <div class="terminal-input">
        <!-- <el-input size="mini" v-model="customer.cname" :placeholder="$t('lang.particulars.Customer')"></el-input> -->
        <div class="project">
          项目列表
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
          <div class="select">
            <div class="select-project">
              <el-tree
                lazy
                style="overflow:auto;height: 200px"
                v-infinite-scroll="scrollLoad"
                ref="customerTrees"
                :highlight-current="true"
                :expand-on-click-node="false"
                @node-click="clickProject"
                :default-expanded-keys="defaultExpand"
                :load="loadNode"
                node-key="cid"
                :data="customerList"
                @current-change="treeChange"
                :props="defaultProps">
                <span class="custom-tree-node" slot-scope="{ node }">
                  <span style="font-size: 16px">{{node.label}}</span>
                </span>
              </el-tree>
            </div>
          </div>  
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { getCustomerList, getUserList } from '@/api/cloudMonitor/deviceConfiguration'
import { getuser_ctid,  } from "@/localStorage/localStorage";
export default {
  data() {
    return {
      defaultProps: {
        chirldren: 'children',
        label: 'cname',
        isLeaf: 'leaf'
      },
      customerList: [],
      customer: {
        cname: '',
        cid: ''
      },
      current: 1,
      size: 20,
    }
  },
  watch: {
    customer: {
      immediate: true,
      deep: true,
      handler() {
        // 获取对应客户的分组
        if(this.customer.cid) {
          this.$emit('getByUser', this.customer.cid)
        }
      }
    }
  },
  computed: {
    defaultExpand() {
      // 默认展开第一项
      if(this.customerList.length > 0) { 
         return [this.customerList[0].cid]
      }else{
        return []
      }
    }
  },
  methods: {
    // 点击项目节点，一级是客户，二级是用户
    clickProject(node) {
      if(node.leaf) { // 点击的是用户才会隐藏下拉
        this.$refs.dropdown.hide()
      }else{ // 点击客户时高亮选项不改变（即客户层级不高亮）
        this.$refs.customerTrees.setCurrentKey(this.customer.cid)
      }
    },
    // 重新选择
    treeChange(node) {
      // 选择的是用户列表
      if(node.leaf) { 
        this.customer = node
      }
    },
    // 动态加载
    async loadNode(node, resolve) {
      // 获取客户列表
      if(node.level === 0) {
        this.fetchCustomer(node, resolve)
      }else{ // 获取用户列表，并把用户层级设置为叶子节点
        getUserList(node.data.cid).then(res => {
          if(res.data.code === 0) {
            let data = res.data.data
            let result = data.map(item =>{
              return {
                cid: item.userId,
                cname: item.userName,
                leaf: true
              }
            })
            resolve(result)
            if (result.length > 0) {
               this.customer = result[0]
               this.$nextTick(() =>{
                 this.$refs.customerTrees.setCurrentKey(this.customer.cid)
               })
            }
          }
        })
      }
    },
    // 滑动滚动条
    scrollLoad() {
      this.current = this.current + 1
      let params = {
        current: this.current,
        size: this.size,
        cid:getuser_ctid()
      }
      getCustomerList(params).then(res => {
        if(res.data.code === 0) {
          let data = res.data.data.records || []
          data.forEach(item => {
            // 追加树形层级
            this.$refs.customerTrees.append(item)
          })
        }
      }).catch(() => {})
      
    },
    // 获取客户列表
    fetchCustomer(node, resolve) {
      let params = {
        current: this.current,
        size: this.size,
        cid:getuser_ctid()
      }
      getCustomerList(params).then(res => {
        if(res.data.code === 0) {
          this.customerList = res.data.data.records
          let data = res.data.data.records || []
          let result = data.map(item => {
            return {
              cid: item.cid,
              cname: item.cname,
            }
          })
          resolve(result)
        }
      }).catch(() => {})
    }
  }
}
</script>
<style scoped>
.el-tree{
  min-width: 200px;
}
.project{
  height: 26px;
  text-align: center;
  line-height: 26px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
}
</style>